import { errorMessageHandler, http } from "../api.services";

export const getServiceCode = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_AGENT_MASTER_SERVICE_CODE!, {
        headers: {
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        cache: "force-cache",
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const getUNcode = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_AGENT_MASTER_UN_CODE!, {
        headers: {
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        cache: "force-cache",
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const CNVerification = async (
  taskId: number,
  cannotNo: string,
  documentType: string,
  roleid: string
) => {
  try {
    // const url = new URL(
    //   `${process.env
    //     .VITE_AWS_AGENT_CN_VERIFICATION!.replace("{taskid}", taskId.toString())
    //     .replace("{cannotNo}", cannotNo)
    //     .replace("{documentType}", documentType)}`
    // );
    // url.searchParams.append("roleid", roleid);
    const data = await http
      .get(
        `${process.env
          .VITE_AWS_AGENT_CN_VERIFICATION!.replace(
            "{taskid}",
            taskId.toString()
          )
          .replace("{cannotNo}", cannotNo)
          .replace("{documentType}", documentType)}&roleid=${roleid}`,
        {
          headers: {
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
          cache: "no-cache",
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const AccountNumberMaster = async (type: string, text: string) => {
  try {
    const url = process.env
      .VITE_AWS_AGENT_ACCOUNT_CODE!.replace("{type}", type)
      .replace("{text}", text);

    const data = await http
      .get(url, {
        headers: {
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        cache: "no-cache",
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getHomeDepot = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_AGENT_MASTER_HOME_DEPOT!, {
        headers: {
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        cache: "force-cache",
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getSubrisk = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_AGENT_MASTER_SUBRISK!, {
        headers: {
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        cache: "force-cache",
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
